import request from '@/utils/request'


// C-查询匿名信分页
export function anonymousLetterList (data) {
  return request({
    url: '/crm/anonymous-letter/page',
    method: 'get',
    params: data
  })
}

// C-新增匿名信
export function anonymousLetter (data) {
  return request({
    url: '/crm/anonymous-letter/add',
    method: 'post',
    data: data
  })
}

// C-获取匿名信详情
export function anonymousLetterdetail (data) {
  return request({
    url: '/crm/anonymous-letter/detail',
    method: 'get',
    params: data
  })
}

// C-标记匿名信已读
export function markRead (data) {
  return request({
    url: '/crm/anonymous-letter/markRead',
    method: 'post',
    data: data
  })
}

// 删除匿名信
export function letterdelete (data) {
  return request({
    url: '/crm/anonymous-letter/delete',
    method: 'post',
    data: data
  })
}

// C-住宿记录管理分页
export function accommodationRecord (data) {
  return request({
    url: '/crm/room/accommodation-record/page',
    method: 'get',
    params: data
  })
}


// C-获取当前登录人所属部门下的宿舍分页列表
export function getLoginDeptRoomPage (data) {
  return request({
    url: '/crm/room/getLoginDeptRoomPage',
    method: 'get',
    params: data
  })
}

// C-街道宿舍图表
export function streetDormitoryChart (data) {
  return request({
    url: '/crm/room/addRoom/streetDormitoryChart',
    method: 'get',
    params: data
  })
}

// C-获取当前登录人所属部门下的宿舍列表
export function getLoginDeptRoomList (data) {
  return request({
    url: '/crm/room/getLoginDeptRoomList',
    method: 'get',
    params: data
  })
}

// C-办理入职选择宿舍信息
export function dormitoryBedPage (data) {
  return request({
    url: '/crm/room/onboarding/dormitoryBedPage',
    method: 'get',
    params: data
  })
}


// C-新增宿舍信息（含房间与床位）
export function addRoom (data) {
  return request({
    url: '/crm/room/add',
    method: 'post',
    data: data
  })
}

// C-查询宿舍房间床位详情
export function getRoomBedDetail (data) {
  return request({
    url: '/crm/room/getRoomBedDetail',
    method: 'get',
    params: data
  })
}


// C-添加宿舍区域下拉列表 添加时候下拉
export function streetDropdown (data) {
  return request({
    url: '/crm/room/addRoom/streetDropdown',
    method: 'get',
    params: data
  })
}

// -查询页面下拉条件 C-街道-宿舍
export function streetDormitoryTree (data) {
  return request({
    url: '/crm/room/addRoom/streetDormitoryTree',
    method: 'get',
    params: data
  })
}


// C-新增设备信息
export function addDevice (data) {
  return request({
    url: '/crm/device/add',
    method: 'post',
    data: data
  })
}

// C-设备管理分页
export function devicePage (data) {
  return request({
    url: '/crm/device/page',
    method: 'get',
    params: data
  })
}


// C-设备领用-归还
export function issuanceReturn (data) {
  return request({
    url: '/crm/employee-device/issuanceReturn',
    method: 'post',
    data: data
  })
}

// C-设备领用记录分页
export function employeedevicepage (data) {
  return request({
    url: '/crm/employee-device/page',
    method: 'get',
    params: data
  })
}


//  补助模块接口
// 新增员工补助
export function subsidyAdd (data) {
  return request({
    url: '/crm/subsidy/add',
    method: 'post',
    data: data
  })
}

// C-补助查询
export function subsidyInquiry (data) {
  return request({
    url: '/crm/employee-subsidy/query/page',
    method: 'get',
    params: data
  })
}

// C-查询员工补助分页
export function subsidyPage (data) {
  return request({
    url: '/crm/subsidy/page',
    method: 'get',
    params: data
  })
}

// 导出员工补助列表
export function exportsubsidy (data) {
  return request({
    url: '/crm/subsidy/export',
    method: 'post',
    data: data
  })
}

// C-补助查询导出
export function subsidyexport (data) {
  return request({
    url: '/crm/employee-subsidy/export',
    method: 'post',
    data: data
  })
}


// C-员工入职信息分页
export function employeePage (data) {
  return request({
    url: '/crm/employee-data/page',
    method: 'get',
    params: data
  })
}


// C-员工面试列表
export function interviewpage (data) {
  return request({
    url: '/crm/employee-data/interview-page',
    method: 'get',
    params: data
  })
}

// C-面试人员信息详情
export function interviewdetail (data) {
  return request({
    url: '/crm/employee-data/interview-detail',
    method: 'get',
    params: data
  })
}


// C-面试通过-不通过状态改变
export function editInterview (data) {
  return request({
    url: '/crm/employee-data/editInterview',
    method: 'post',
    data: data
  })
}

// C-转正-申请离职-办理离职
export function editStatus (data) {
  return request({
    url: '/crm/employee-data/editStatus',
    method: 'post',
    data: data
  })
}



// C-办理入职
export function onboarding (data) {
  return request({
    url: '/crm/employee-data/onboarding',
    method: 'post',
    data: data
  })
}

// 获取当前公司下面所有手机-电脑
export function phonesPage (data) {
  return request({
    url: '/crm/device/phones/page',
    method: 'get',
    params: data
  })
}


// C-信息维护
export function informationMaintenance (data) {
  return request({
    url: '/crm/employee-data/informationMaintenance',
    method: 'post',
    data: data
  })
}


// C-新增离职申请
export function resignationAdd (data) {
  return request({
    url: '/crm/resignation/add',
    method: 'post',
    data: data
  })
}


// 新政支出
// C-行政支出列表
export function sheetPage (data) {
  return request({
    url: '/crm/sheet/page',
    method: 'get',
    params: data
  })
}


// C-获取当前登录人所属部门下的街道小区数据
export function getLoginDeptStreetCommunityTree (data) {
  return request({
    url: '/crm/room/getLoginDeptStreetCommunityTree',
    method: 'get',
    params: data
  })
}


// C-查询考勤设置列表
export function attendanceList (data) {
  return request({
    url: '/crm/attendance-time/list',
    method: 'get',
    params: data
  })
}

// C-编辑考勤设置
export function attendanceEdit (data) {
  return request({
    url: '/crm/attendance-time/edit',
    method: 'post',
    data: data
  })
}


// C-考勤记录分页
export function attendancePage (data) {
  return request({
    url: '/crm/attendance/page',
    method: 'get',
    params: data
  })
}

// C-新增行政支出总
export function sheetAdd (data) {
  return request({
    url: '/crm/sheet/add',
    method: 'post',
    data: data
  })
}

// C-编辑行政支出总
export function sheetEdit (data) {
  return request({
    url: '/crm/sheet/edit',
    method: 'post',
    data: data
  })
}


// 获取行政支出总详情
export function sheetDetail (data) {
  return request({
    url: '/crm/sheet/detail',
    method: 'get',
    params: data
  })
}
